<template>
  <div class="Footer__warp">
    <div class="logo" >
      <img src="../../public/static/footer/footer_logo_nstl.png"/>
    </div>
    <div class="desc">
      <span>关于平台</span>
      <em>|</em>
      <span>技术支持</span>
      <em>|</em>
      <span>关于我们</span>
      <em>|</em>
      <span>网站声明</span>
    </div>
  </div>
</template>

<script>
import {DetectionIp} from "@/util/login";

export default {
  name:'Footer',
  data(){
    return {
      path:""
    }
  },
  mounted () {

  },
  methods: {
    getIPAddress() {
      // console.log("host",DetectionIp())
      return DetectionIp();
    },
  }
}
</script>

<style lang="scss" scoped>
  .Footer__warp{
    width: 100%;
    height: 60px;
    background: url('../../public/static/footer/footer_bj_nstl.png') no-repeat;
    //background: #1966ae;
    background-size: cover;
    display: flex;
    align-items: center;
    gap: 16px;
    min-width: 1100px;
    position: fixed;
    bottom: 0;
    z-index: 101;
     em{
      margin: 0;
      padding: 0;
      outline: none;
    }

    address, cite, dfn, em, i, var {
      font-style: normal;
    }
  }
  .logo{
    float: left;
    margin-left: 30px;
    width: 210px;
    img{
      //height: 34px;
      height: 30px;
    }
  }
  //.desc{
  //  line-height: 60px;
  //  width: calc(100% - 480px);
  //  text-align: center;
  //  color: #84ace8;
  //  font-size: 14px;
  //  span{
  //    display: inline-block;
  //  }
  //  em{
  //    margin: 0px 20px;
  //    display: inline-block;
  //  }
  //}
  .desc{
    line-height: 60px;
    width: calc(100% - 290px);
    text-align: right;
    color: #84ace8;
    font-size: 14px;
    span{
      display: inline-block;
    }
    em{
      margin: 0px 20px;
      display: inline-block;
    }
  }

</style>